import { render, staticRenderFns } from "./addOtaDevice.vue?vue&type=template&id=30ffcca2&scoped=true"
import script from "./addOtaDevice.vue?vue&type=script&lang=js"
export * from "./addOtaDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ffcca2",
  null
  
)

export default component.exports